/**
 * defa.models.PhoneNumber
 * The DEFA PhoneNumber model
 * @version 1.2.1
 */
import { defa } from 'defa-object';
import Model    from 'scripts/poppet/model';

const channel = Bb.Radio.channel( 'objects' );
	
const api = {
	phone: defa.vars.apiHost + '/phonenumbers',
};
	
const PhoneNumber = Model.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
		
	urlRoot : api.phone,
		
	defaults : {
		user        : '',
		prefix      : '',
		number      : '',
		description : '',
	},
		
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
		
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
		
	/**
		 * Parses incoming data before creating the model.
		 * @param  {object} response  The response from the server.
		 * @return {object}           The parsed response.
		 * @overwrite
		 */
	parse: function( response ) {
			
		channel.request( 'phoneNumbers' ).add( response, { merge: true } );
			
		return response;
	},
		
	/**
		 * Creates a name for the number based on the description and number.
		 * @return {String} A logical name for the number.
		 */
	numberName: function() {
			
		let name = '';
			
		let description = ( _.isString( this.get( 'description' )))
			?  ' - ' + this.get( 'description' ).trim()
			: '';
			
		name += this.get( 'prefix' ) + ' ' + this.get( 'number' );
		name += description;
			
		return name.trim();
	},
		
});

export default PhoneNumber